
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison/privacy-policy",
      function () {
        return require("private-next-pages/vpnpricecomparison/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vpnpricecomparison/privacy-policy"])
      });
    }
  